import { defineMessages } from "react-intl"

export const offerListMessages = defineMessages({
	creationDate: {
		defaultMessage: "Creation Date",
		id: "vehicleDetails.salesActivity.offerOverview.offerList.creationDate",
	},
	offerCode: {
		defaultMessage: "Offer code",
		id: "vehicleDetails.salesActivity.offerOverview.offerList.offerCode",
	},
	price: {
		defaultMessage: "Price",
		id: "vehicleDetails.salesActivity.offerOverview.offerList.price",
	},
	salesperson: {
		defaultMessage: "Salesperson",
		id: "vehicleDetails.salesActivity.offerOverview.offerList.salesPerson",
	},
	tradeIn: {
		defaultMessage: "Trade In",
		id: "vehicleDetails.salesActivity.offerOverview.offerList.tradeIn",
	},
})
